// extracted by mini-css-extract-plugin
export default {"root":"Comparables__root--y3L7s","title":"Comparables__title--JXRGz","comparables":"Comparables__comparables--GfWVo"};